<template>
  <div class="container">
    <h1>DevBeat</h1>
    <form>
      <div class="form-control">
        <input
          id="email"
          v-model="email"
          name="email"
          type="text"
          required
        >
        <label for="email" :style="emailStyles">Email</label>
      </div>
      <div class="form-control">
        <input
          id="password"
          v-model="password"
          name="password"
          type="password"
          required
        >
        <label for="password" :style="passwordStyles">Password</label>
      </div>
      <div class="form-control" style="margin-bottom: 0; text-align: right;">
        <button @click.prevent="handleSubmission($event)">
          Submit
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { user } from '@/httpService'
import authService from '@/authService'

export default {
  name: 'LoginForm',
  data() {
    return {
      emailActive: false,
      passwordActive: false,
      email: '',
      password: '',
    }
  },
  computed: {
    emailStyles() {
      return this.email.length > 0 ? { opacity: 0 } : { opacity: 0.5 }
    },
    passwordStyles() {
      return this.password.length > 0 ? { opacity: 0 } : { opacity: 0.5 }
    },
  },
  methods: {
    async handleSubmission() {
      const response = await user.postUserLoginData({ email: this.email, password: this.password })

      const payload = await response.json()
      if (response.status >= 400) {
        // eslint-disable-next-line no-alert
        alert('Login failed. Check your credentials')
        return
      }
      authService.setPayload(payload.content)
      this.$router.push({ name: 'user' })
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables' as *;

h1 {
  font-family: Roboto, sans-serif;
  margin-bottom: 42px;
  text-align: center;
}
.container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 400px;
}
.form-control {
  position: relative;
  margin-bottom: 24px;
  display: block;
  width: 100%;
}
input, label {
  display: block;
  color: lighten($color--gray, 50%);
  line-height: 16px;
}
label {
  position: absolute;
  top: 16px;
  left: 16px;
  font-size: 16px;
}
input {
  -webkit-appearance: none;
  outline: none;
  border: 0;
  padding: 16px;
  background-color: lighten($color--gray, 10%);
  width: 100%;
  cursor: text;
  font-size: 16px;
}
button {
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  color: lighten($color--gray, 50%);
  background-color: lighten($color--gray, 10%);
  box-shadow: 0px 0px 0px transparent;
  border: 0px solid transparent;
  text-shadow: 0px 0px 0px transparent;
  padding: 12px 24px;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
}
</style>
